import { DISABLE_PAGE_INDEXING, ENABLE_PAGE_INDEXING } from 'contexts/CruiseSearchContext/constants';
import { makeStoreFromRouteQuery } from 'contexts/CruiseSearchContext/utils/filterParser';
import { getMetadataValues } from 'contexts/CruiseSearchContext/utils/metadataUtils';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface SearchHeaderProps {
	serverSideMetadata: any; // TODO: add type
	filterOptionsDictionary: any; // TODO: add type
	config: any; // TODO: add type
	locale: any; // TODO: add type
	enablePageIndexing: boolean;
	dictionaries: Record<string, object>
}

const SearchHeader = ({ serverSideMetadata, filterOptionsDictionary, config, locale, enablePageIndexing, dictionaries }: SearchHeaderProps) => {
	const { query = {}, asPath } = useRouter();
	const [metadata, setMetadata] = useState(serverSideMetadata);

	const urlParamsObject = makeStoreFromRouteQuery(query);

	useEffect(() => {
		setMetadata(getMetadataValues(urlParamsObject, '', filterOptionsDictionary, asPath, config, locale, dictionaries.cruiseSearchDictionary));
	}, [asPath]);

	return (
		<Head>
			<title key="title">{metadata?.title}</title>
			<link key="canonical" rel="canonical" href={metadata?.canonical} />
			<meta key="description" name="description" content={metadata?.description} />
			<meta key="og:title" property="og:title" content={metadata?.title} />
			<meta key="og:description" property="og:description" content={metadata?.description} />
			<meta key="content-language" httpEquiv="content-language" content={locale?.code} />
			<meta key="og:image" property="og:image" content={metadata?.image} />
			<meta key="og:site_name" property="og:site_name" content={`${metadata?.ogSiteName}`} />
			<meta key="og:phone_number" property="og:phone_number" content={locale?.phoneNumber ? locale.phoneNumber : 'N/A'} />
			<meta key="robots" name="robots" content={enablePageIndexing ? ENABLE_PAGE_INDEXING : DISABLE_PAGE_INDEXING} />
		</Head>
	);
};

export default SearchHeader;
